/**
 * Events / Calendar — full interactive calendar (FullCalendar).
 */
import React from 'react';
import PageLayout from '../components/ui/PageLayout';
import EventsCalendar from '../components/EventsCalendar';

const EventsPage = () => {
  const handleOptionSelect = (option) => {
    if (option === 'home') window.location.href = '/dashboard';
    else if (option === 'folder') window.location.href = '/files/clients/root';
    else if (option === 'settings') window.location.href = '/settings';
  };

  return (
    <PageLayout onOptionSelect={handleOptionSelect} maxWidth="none" padding={0} chromePadding={3} sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <EventsCalendar />
    </PageLayout>
  );
};

export default EventsPage;
